import React, {Component} from 'react'

export default class UsedCredit extends Component {

    constructor(props) {
        super()
        this.state = {
            usedcredits: props.usedcredits
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            usedcredits: nextProps.usedcredits
        })
    }

    getType = type => {
        if (!type) return
        let formattedType = type
        switch (type) {
            case 'bank':
                formattedType = 'Bank'
                break
            case 'customer_cash':
                formattedType = 'Vevő készpénz'
                break
            case 'customer_transfer':
                formattedType = 'Vevő utalás'
                break
            case 'cashregister':
                formattedType = 'Pénztárgép'
                break
            default:
                formattedType = 'Vevő'
                break

        }

        return formattedType
    }


    render() {
        if (!this.state.usedcredits.length) {
            return <h1 className='font-size-14'>Nincs megjeleníthető adat.</h1>
        }
        return (
            <section id='used-credits'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <table className='table table-striped  table-aibook-no-border'>
                                <thead>
                                <tr>
                                    <th>Dátum</th>
                                    <th>Cég</th>
                                    <th>Kontírozás db.</th>
                                    <th>Egység ár</th>
                                    <th>Felhasznált egyenleg</th>
                                    <th>Típus</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.usedcredits.length ?
                                    this.state.usedcredits.map((item) => {
                                        return <tr key={item.id}>
                                            <td>{item.created_at}</td>
                                            <td>{item.company}</td>
                                            <td>{item.items_count} db.</td>
                                            <td>{item.unit_price} HUF</td>
                                            <td>{item.usedCredit} HUF</td>
                                            <td>{this.getType(item.type)}</td>
                                        </tr>
                                    })
                                    : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/history/usedcredit.js